// removed by extract-text-webpack-plugin
module.exports = {"button":"cWAz8z1DT8EoFJKDZn51j","backButton":"_2MY6az-JbVQhahNwv31pk2 cWAz8z1DT8EoFJKDZn51j"};


//////////////////
// WEBPACK FOOTER
// ./src/common/NextButton.css
// module id = 554
// module chunks = 0